import { IThemeInterface } from "../components/Provider/types"

const getColumnSize = (columnCount: number) => ({
  theme,
}: {
  theme: IThemeInterface
}) => `${(columnCount / theme.grid.columns) * 100}%`

export default getColumnSize
